<template>

  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App",
    data() {
      return {

        domain_url:'',

      }
    },
    mounted() {
    this.domain_url = window.location.hostname;
    console.log(this.domain_url)
    this.login_title ='陇教云通睿心理测评系统(学生端)'
    if(this.domain_url =='shanxi.mxlcp.bi-soft.cn'){
        this.login_title ='陕西教育云通睿心理测评系统(学生端)'
    }else if(this.domain_url =='gansu.mxlcp.trjykj.cn'){
         this.login_title ='陇教云通睿心理测评系统(学生端)'
    }
     document.title = this.login_title
    // this.getsjtjs();
     },
};

</script>

<style>
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
.width200 {width: 200px;}
.width300 {width: 300px;}
.width400 {width: 400px;}
.width500 {width: 500px;}
.width600 {width: 600px;}
 .success-row {
      background-color:#E8E8E8 !important;

  }
  /* 自定义选中单选框的背景色 */
  .el-radio__input.is-checked .el-radio__inner {
    background-color: #00DDA3; /* 你想要的任何颜色 */
    border-color: #00DDA3;
    color: #00DDA3;
  }
/* 修改Element UI单选框选中时的文字颜色 */
.el-radio__input.is-checked + .el-radio__label {
  color: #00DDA3; /* 例如: #409EFF */
}
  /* 如果你想要改变选中时的边框颜色，也可以加入以下代码 */
  .el-radio__input.is-checked .el-radio__inner::after {
    background-color: #fff; /* 选中后对角线的颜色 */
  }
  .custom-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
    color: #00DDA3; /* 设置选中后的文本颜色为红色 */
  }

  /* 修改复选框大小 */
  .el-checkbox__input .el-checkbox__inner {
    width: 12px; /* 设置宽度 */
    height: 12px; /* 设置高度 */
  }

  /* 修改复选框选中颜色 */
  /* .el-checkbox__input .el-checkbox__inner::after {
    border-color: #00DDA3; /*
    background-color: #00DDA3;
  } */

  /* 当复选框被禁用时，修改颜色 */
  .el-checkbox__input.is-disabled .el-checkbox__inner::after {
    border-color: #dcdfe6;
    background-color: #eef1f6;
  }
  .custom-checkbox .el-checkbox__input.is-checked .el-checkbox__inner,
  .custom-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #00DDA3; /* 你想要的背景色 */
    border-color: #00DDA3;
    color: #00DDA3;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color:#00DDA3;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #00DDA3;
      border-color: #00DDA3;
  }
  .el-checkbox__label {

      font-size: 11px;
  }
  .headbt{
    height: 40px;
    width: 100%;
    line-height: 40px;
    background-color: #00DDA3;
    text-align: center;
    font-size: 16px;
    color: white;
    font-weight: bold;
  }
  .jbk{
    width: 100%;
    height: 100px;
  }
  .zjt{
        width: 22px;
        height: 22px;
        float: left;
        margin-top: 8px;
  }
  .zjt img{
  	width: 22px;
  	height: 22px;
    float: left;
    margin-left: 10px;

  }
  .footer {
    position: fixed ;
    bottom: 0;
    width: 100%;
    height: 60px !important; /* 底部栏的高度 */

    background-color: white;
    display: flex;
    border-top: solid 1px #E6EAEC;

    margin-left:  0 !important;
  }
  .item_list_menu{
  	/* border: solid 1px red; */
  	text-align: center;
  }
  .dibumenu{
  	width: 100%;
  	text-align: center;
  	padding-top: 3px;
  }
  .dibumenu img{
  	width: 24px;
  	height: 24px;
  }
  .xmtitle{
  	text-align: center;
  	font-size: 12px;
  	color: #666666;
  }
  .xmtitle_active{
  	color: #00DDA3;
  }
  .rwgl img{
    width: 100%;
    height: 100%;
  }
  .jiahong{
    color: red;
  }
  .jzxyy{
    width: 100%;
    height: 35px;
    text-align: center;
    margin-top: 25px;
    color: #ccc;
    font-size: 12px;
  }
  .djjzxyy{
    width:30%;
    height: 35px;
    margin: 0 auto;
    /* border: solid 1px red; */
    line-height: 35px;
  }
  .xingxing{
  	color:red;
  }
  .el-message-box{
    width: 80% !important;
  }
.el-button--primary{
  background-color: #38B3FF;
      border-color: #38B3FF;
}
.jialv{
  color: #38B3FF;
}
.jslh{
  white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/App.vue